import { render, staticRenderFns } from "./TeacherPosition.vue?vue&type=template&id=1a1f0e5e"
import script from "./TeacherPosition.vue?vue&type=script&lang=js"
export * from "./TeacherPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports